import * as React from 'react';
import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const ErrorStyle = styled.div`
  ${tokens.text('caption')};
  padding: ${tokens.spacer.x1} 0 ${tokens.spacer.x0};
  color: ${tokens.color.text_danger};
`;

interface ErrorTextProps {
  children: React.ReactNode | string;
  className?: string;
}

export const ErrorText = ({ children, ...props }: ErrorTextProps): JSX.Element => (
  <ErrorStyle {...props}>{children}</ErrorStyle>
);
